import { useMetricDrilldown } from '../context/MetricDrilldownContext';
import { getSectionActions } from '../utils/getSectionActions';

export const useSectionL2Modal = () => {
  const { openSection, close } = useMetricDrilldown();
  const open = Boolean(openSection);
  const actions = openSection ? getSectionActions(openSection) : [];
  const l2ActionLabel = actions.find(action => action.navigation?.type === 'L2')?.label;
  const firstActionLabel = actions[0]?.label;

  // Prefer overline when title is lifted from the metric (title shows inside the card).
  const title = openSection?.titleFromMetric
    ? openSection.overline || l2ActionLabel || firstActionLabel || 'Section detail'
    : openSection?.title ||
      openSection?.overline ||
      l2ActionLabel ||
      firstActionLabel ||
      'Section detail';

  return {
    open,
    section: openSection,
    title,
    overline: openSection?.titleFromMetric ? undefined : openSection?.overline,
    onClose: close,
  };
};
